export const PLAY_MESSAGE = 'Nope, I don\'t have the copyright to play this movie!';
